import { render, staticRenderFns } from "./OrderWithoutRoute.vue?vue&type=template&id=bdb06c56&scoped=true"
import script from "./OrderWithoutRoute.vue?vue&type=script&lang=js"
export * from "./OrderWithoutRoute.vue?vue&type=script&lang=js"
import style0 from "./OrderWithoutRoute.vue?vue&type=style&index=0&id=bdb06c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb06c56",
  null
  
)

export default component.exports